RivalIQ.module('export.enums', function (enums, App, Backbone, Marionette, $, _) {

    'use strict';

    enums.status = {
        FAILED: -1,
        IN_PROGRESS: 0,
        SUCCESS: 1,
        PENDING: 2
    };

    enums.DEFAULT_SCHEDULED_REPORT_TIME = 10;
});
